// import logo from './logo.svg';
import './App.css';
 
import Navbar from './components/Ui/Navbar';
 
import Footer from './components/Ui/Footer';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NavFoot from './components/Main/NavFoot';
import Main from './components/Main/Main';
import AboutUs from './components/PAGES/AboutUs';
// import Service from './components/PAGES/Service';
import Products from './components/PAGES/Products';
import Contactuspage from './components/PAGES/Contactus';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
//     <div >
//       <Navbar/>
//  <Footer/>
//  {/* <Certified/> */}
//     </div>

<BrowserRouter>
<ScrollToTop
/>
<Routes>
  <Route path="/" element={<NavFoot/>}>
  <Route index element={<Main/>}/>
  <Route path="about"element={<AboutUs/>}/>
  <Route path="products"element={<Products/>}/>
  <Route path="contact"element={<Contactuspage/>}/>
  </Route>
  </Routes>
</BrowserRouter>

  );
}   

export default App;
